enum CommonMarketplaceEnum {
    EPICENTR = 'epicentr',
    ROZETKA = 'rozetka',
    KASTA = 'kasta',
    PROM = 'prom',
    MAUDAU = 'maudau',
    EVA = 'eva',
    ALLO = 'allo'
}

function getCommonMarketplaces(): string[] {
    return Object.values(CommonMarketplaceEnum);
}

export { CommonMarketplaceEnum, getCommonMarketplaces };
